import React from 'react';

import { UndoOutlined } from '@ant-design/icons';
import { Table as AntTable, Button, Input, TableProps, theme, Tooltip } from 'antd';
import { isEqual } from 'lodash';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { ViewProductSchema } from '@app/models/products';

import { searchProducts } from '@pages/Catalogs/components/Form/components/ProductsModal/components/ContentContainer/components/CatalogTable/services';
import { useProductModal } from '@pages/Catalogs/providers';

import { BASE_COLUMNS } from './constants';
import { TableControlsContainer } from './styles';

interface IProps {
  test?: string;
}

export const CatalogTable: React.FC<IProps> = ({ test }) => {
  const [y, setY] = React.useState<number>(400);
  const nomenclatureInfoT = useTranslation(NSKeys.nomenclatureInfo);
  const nomenclatureListT = useTranslation(NSKeys.nomenclatureList);
  const catalogsT = useTranslation(NSKeys.catalogs);
  const [searchResult, setSearchResultState] = React.useState('');
  const [search, setSearchState] = React.useState('');
  const { token } = theme.useToken();

  const { selectedRows, onSelectChange, resultProducts } = useProductModal();

  React.useEffect(() => {
    const update = () => setY(window.innerHeight - 260);
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  const handleChange = (_: any, rows: any[]) => {
    onSelectChange(rows);
  };

  const rowSelection: TableProps<ViewProductSchema>['rowSelection'] = {
    selectedRowKeys: selectedRows?.map((el) => el.uid),
    onChange: handleChange,
  };

  const handleSearchClick = (value?: string) => {
    setSearchResultState(value || '');
  };

  const handleSearchBlur = (value?: string) => {
    setSearchState(value || '');
    setSearchResultState(value || '');
  };

  const handleResetChanges = () => {
    onSelectChange(resultProducts);
  };

  return (
    <div style={{ padding: '0 24px' }}>
      <TableControlsContainer>
        {!isEqual(resultProducts, selectedRows) && (
          <Tooltip title={catalogsT.t('resetChanges')}>
            <Button icon={<UndoOutlined style={{ color: token.colorPrimary }} />} onClick={handleResetChanges} />
          </Tooltip>
        )}
        <Input.Search
          style={{ maxWidth: 240 }}
          size="middle"
          value={search}
          onChange={(e) => {
            setSearchState(e.target.value);
          }}
          placeholder={nomenclatureListT.t('searchButton')}
          enterButton
          onBlur={(e) => {
            handleSearchBlur(e.target.value);
          }}
          onSearch={handleSearchClick}
          allowClear
        />
      </TableControlsContainer>
      <AntTable<ViewProductSchema>
        columns={[
          ...BASE_COLUMNS.map((el, index) => ({
            ...el,
            title: nomenclatureInfoT.t(el.title as any),
            render: BASE_COLUMNS.find((baseCol) => baseCol.key === el.key)?.render,
          })),
        ]}
        rowSelection={rowSelection}
        size="middle"
        key="uid"
        rowKey="uid"
        pagination={false}
        className="tableClassname"
        loading={false}
        dataSource={searchProducts(selectedRows, searchResult)}
        scroll={{ y }}
      />
    </div>
  );
};
